import { Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { langCommon, langPage, langTableColumns } from "../../../locales";
import { floatNumberInThousands } from "../../../utils/tools"
import { FormConfigType } from "../../../components/editForm";

const langRecharge = langPage?.amount;
const lang = langPage?.amount?.balanceLog;


export const DEFAULT_QUERY_DATA = {
    Email: null,
}

export const generateQueryFormConfig = (): FormConfigType => {
    return [
        {
            title: langRecharge?.email,
            type: "input",
            field: "Email",
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {

    return [
        {
            title: 'id',
            dataIndex: "Id",
        },
        {
            title: langRecharge?.email,
            dataIndex: "Email",
            render(value, record, index) {
                return value || record.Member?.Email
            },
        },
        {
            title: "收益金额",
            dataIndex: "Income",
        },
        {
            title: "收益日期",
            dataIndex: "Date",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
    ]
}
